import {
  useAgentCallAgenda,
  useClientListQuery, useTagsQuery
} from '..';
import { getDateRangeFromPeriod, Periodic } from '../../features';
import { useEffect, useMemo } from 'react';
import { ClientViewFilterInput, ClientViewSortInput, PageInput } from '@coverright/data-access/types/enrollment';
import _ from 'lodash';


export type ClientFilter = Periodic<Periodic<ClientViewFilterInput, 'range'>, 'followUpDate'>

export const useClients = (pageInput: PageInput, filters?: ClientFilter, sort?: ClientViewSortInput, partner?: string) => {
  const {data: tagsData} = useTagsQuery()
  const tags = useMemo(() => tagsData?.tags || [], [tagsData]);

  const filterInput = useMemo(() => {
    let partnerFilter: any = undefined;
    if (partner) {
      const partnerTag = tags.find(t => t.name.toLowerCase().replace(' ', '') === partner.toLowerCase())
      partnerFilter = {
        justNerdWallet: partner === 'nerdWallet',
        tags: partnerTag ? [partnerTag.id] : undefined,
      }
    }
    if (filters) {
      const v = {
        ...filters,
        ...partnerFilter,
        tags: _.uniq([...(filters.tags || []), ...(partnerFilter?.tags || [])]),
        range: getDateRangeFromPeriod(filters.range),
        followUpDate: getDateRangeFromPeriod(filters.followUpDate),
      }
      return v
    } else {
      return partnerFilter
    }
  }, [filters, partner, tags]);

  const {state} = useAgentCallAgenda();

  const {data: newData, previousData, loading, refetch} = useClientListQuery({
    variables: {
      filterInput,
      pageInput,
      sort
    },
    fetchPolicy: 'cache-and-network',
    skip: !!partner && !tags.length
  })

  useEffect(() => {
    refetch();
  }, [state?.rrView.tasksWaitingPool, refetch]);

  const data = newData || previousData;

  const clients = data?.clientViews.data || [];

  return {clients, loading, total: data?.clientViews.totalElements, refetch}
}



